import { isVimeo, isYoutube } from '../../components/rich-editor-2/video/video-utils';
import YoutubeEmbed from '../../components/youtube-embed/YoutubeEmbed';
import VimeoEmbed from '../../components/vimeo-embed/VimeoEmbed';

const ProjectVideo = ({ url, loop }) => {
    if (url && isYoutube(url)) {
        return <YoutubeEmbed url={url} autoplay mute controls={false} loop={loop} />;
    }

    if (url && isVimeo(url)) {
        return <VimeoEmbed url={url} background autoplay loop={loop} />;
    }

    return null;
};

export default ProjectVideo;
